import React from 'react';
import { Footer } from '../Common/Footer';
import { BuyerSidebar } from '../Common/BuyerSidebar';
import Buyer from '../../Models/Buyer';
import { Header } from '../Common';
import Profile from '../../Models/Profile';
import 'react-toastify/dist/ReactToastify.css';
import { SideBar } from '../Common/SideBar';

class BuyerViewProfile extends React.Component {
    constructor(props) {
        super(props);
        // notifyA = () => toast('Wow so easy !', {containerId: 'A'});
        let x = JSON.parse(localStorage.getItem('info'))
        if (x === null || x === '') {
            alert('ログインしてください')
            window.location.href = '/login';
        };
        var retrievedObject = window.localStorage.getItem('info');
        var logged_user = JSON.parse(retrievedObject);
        this.state = {
            _id: false,
            user: logged_user,
            modal: false,
            profession: '',
            photo_id: null,
            utility: null,
            residential: [],
            services: [],
            portfolio: [],
            sex: [],
            area: '',
            address: '',
            x: '',
            profile_picture: null,
            profile: [],
            username: '',
            phone: '',
            email: '',
            creditcard: '',
            t_account: ''
        };
        console.log(this.props.match.params.id)
    }

    componentDidMount() {
        window.scrollTo(0, 0)
        Profile.getResidentials().then(res => {
            if (res.data.area != null) {
                this.setState({ residential: res.data.area })
            }
        })
        Profile.getSex().then(res => {
            if (res.data.sex != null) {
                this.setState({ sex: res.data.sex })
            }
        })
        if (this.props.match.params.id) {
            Profile.getBasics(this.props.match.params.id).then(res => {
                if (res.data.payloads != null) {
                    this.setState({ profile: res.data.payloads })
                    this.setState({ profession: res.data.payloads.profession })
                    this.setState({ photo_id: res.data.payloads.pid })
                    this.setState({ profile_picture: res.data.payloads.img })
                    this.setState({ utility: res.data.payloads.ut })
                    this.setState({ x: res.data.payloads.sex })
                    this.setState({ area: res.data.payloads.residential_area })
                    this.setState({ address: res.data.payloads.address })
                }
            })
            Profile.getConfiguration(this.props.match.params.id).then(res => {
                if (res.data.payload != null) {
                    this.setState({ username: res.data.payload.first_name })
                    this.setState({ phone: res.data.payload.phone })
                    this.setState({ email: res.data.payload.email })
                    this.setState({ creditcard: res.data.payload.credit_card })
                    this.setState({ t_account: res.data.payload.transfer_account })
                }
            })
        } else {
            // if (this.props.location.state === null||this.props.location.state === ''||this.props.location.state === 'undefined'){
            Profile.getBasics(this.state.user.id).then(res => {
                if (res.data.payloads != null) {
                    this.setState({ profile: res.data.payloads })
                    this.setState({ profession: res.data.payloads.profession })
                    this.setState({ photo_id: res.data.payloads.pid })
                    this.setState({ profile_picture: res.data.payloads.img })
                    this.setState({ utility: res.data.payloads.ut })
                    this.setState({ x: res.data.payloads.sex })
                    this.setState({ area: res.data.payloads.residential_area })
                    this.setState({ address: res.data.payloads.address })
                }
            })
            Profile.getConfiguration(this.state.user.id).then(res => {
                if (res.data.payload != null) {
                    this.setState({ username: res.data.payload.first_name })
                    this.setState({ phone: res.data.payload.phone })
                    this.setState({ email: res.data.payload.email })
                    this.setState({ creditcard: res.data.payload.credit_card })
                    this.setState({ t_account: res.data.payload.transfer_account })
                }
            })
        }
    }

    onChangePro(e) {
        this.setState({ profile_picture: e.target.files[0] })
    }

    updateValue(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }

    details(details) {
        const renderHTML = (rawHTML) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });
        if (details === null || details === '') {
            return (
                renderHTML(details)
            )
        } else {
            return (
                renderHTML(details.substr(0, 50))
            )
        }
    }

    SideBar() {
        if (localStorage.getItem('info') !== null) {
            var x = JSON.parse(localStorage.getItem('info'))
            if (x.user_type_id === 1) {
                return (
                    <div >
                        <BuyerSidebar />
                    </div>
                )
            } else if (x.user_type_id === 2) {
                return (
                    <div >
                        <SideBar />
                    </div>
                )
            }
        }
    }

    profileImage() {
        if (this.state.profile.img === '' || this.state.profile.img === null) {
            return (
                <div style={{ width: "100%", textAlign: "center" }}>
                    <img style={{ borderRadius: "50%" }} alt="" src={this.state.profile_picture} height="100" width='100' />
                </div>
            )
        } else {
            return (
                <div style={{ width: "100%", textAlign: "center" }}>
                    <img style={{ borderRadius: "50%" }} alt="" src={this.state.profile_picture} height="100" width='100' />
                </div>
            )
        }
    }

    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if (isMobile) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="container-fluid">
                        <div className="row" style={{ minHeight: '568px' }}>
                            {/* <div className="col-md-4 input_name">
                                        {this.SideBar()}
                                    </div> */}
                            <div className="col-md-12 col-sm-12">
                                <div className="mt-5 mb-3 input_name big_font guide_text" style={{ width: "100%", fontSize: '20px' }}>
                                    プロフィール
                                </div>
                                <div className="mt-3 row" style={{ height: '100px' }}>
                                    <div className="col-md-4"></div>
                                    <div className="col-md-4">
                                        {this.profileImage()}
                                    </div>
                                </div>
                                <div className="mt-2" style={{ border: "1px solid rgb(241, 240, 238)", padding: "12px", textAlign: "center", height: "auto", fontSize: "13px" }}>

                                    <fieldset className="fieldset_border">
                                        <legend className="fieldset_legend" style={{ width: "30%", }}>ユーザー名</legend>
                                        <span><div className="pb-1" style={{ textAlign: "left" }}>{this.state.username}</div></span>
                                    </fieldset>
                                    <br />
                                    <fieldset className="fieldset_border">
                                        <legend className="fieldset_legend" style={{ width: "40%", }}>メールアドレス</legend>
                                        <span><div className="pb-1" style={{ textAlign: "left" }}>{this.state.email}</div></span>
                                    </fieldset>
                                    <br />
                                    <fieldset className="fieldset_border">
                                        <legend className="fieldset_legend" style={{ width: "15%", }}>性別</legend>
                                        <span><div className="pb-1" style={{ textAlign: "left" }}>{this.state.profile.sx}</div></span>
                                    </fieldset>
                                    <br />
                                    <fieldset className="fieldset_border">
                                        <legend className="fieldset_legend" style={{ width: "35%", }}>都道府県選択</legend>
                                        <span><div className="pb-1" style={{ textAlign: "left" }}>{this.state.profile.area}</div></span>
                                    </fieldset>
                                    <br />
                                    <fieldset className="fieldset_border">
                                        <legend className="fieldset_legend" style={{ width: "15%", }}>住所</legend>
                                        <span>
                                            <div className="pb-1" style={{ textAlign: "left" }}>
                                                {(() => {
                                                    if (this.state.address !== null) {
                                                        return (
                                                            this.state.address.split('\n').map((item, key) =>
                                                                <span key={key}>
                                                                    {item}
                                                                    <br />
                                                                </span>
                                                            )
                                                        )
                                                    } else {
                                                        return (
                                                            <div className=""></div>
                                                        )
                                                    }
                                                })()}
                                            </div></span>
                                    </fieldset>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        } else if (isDesktop) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row" style={{ minHeight: '568px' }}>
                                    <div className="col-md-4 input_name">
                                        {this.SideBar()}
                                    </div>
                                    <div className="col-md-8 col-sm-8">
                                        <div className=" mb-3 input_name big_font guide_text" style={{ width: "100%" }}>
                                            プロフィール
                                    </div>
                                        <div className="container">
                                            <div className="mt-3 row" style={{ height: '100px' }}>
                                                <div className="col-md-4"></div>
                                                <div className="col-md-4">
                                                    {this.profileImage()}
                                                </div>
                                            </div>
                                            <div className="mt-2" style={{ border: "1px solid rgb(241, 240, 238)", padding: "22px", textAlign: "center", height: "auto", }}>
                                                <div className="col-md-12 row">
                                                    <div className="col-md-4" style={{ textAlign: "right" }}>
                                                        <b><i>性別:</i></b>
                                                    </div>
                                                    <div className="col-md-1"></div>
                                                    <div className="col-md-7" style={{ textAlign: "left" }}>
                                                        {this.state.profile.sx}
                                                    </div>
                                                </div>
                                                <div className="col-md-12 row">
                                                    <div className="col-md-4" style={{ textAlign: "right" }}>
                                                        <b><i>都道府県選択:</i></b>
                                                    </div>
                                                    <div className="col-md-1"></div>
                                                    <div className="col-md-7" style={{ textAlign: "left" }}>
                                                        {this.state.profile.area}
                                                    </div>
                                                </div>
                                                <div className="col-md-12 row">
                                                    <div className="col-md-4" style={{ textAlign: "right" }}>
                                                        <b><i>住所:</i></b>
                                                    </div>
                                                    <div className="col-md-1"></div>
                                                    <div className="col-md-7" style={{ textAlign: "left", height: "50px" }}>
                                                        {this.state.profile.address}
                                                    </div>
                                                </div>
                                                <div className="col-md-12 row">
                                                    <div className="col-md-4" style={{ textAlign: "right" }}>
                                                        <b><i>ユーザー名:</i></b>
                                                    </div>
                                                    <div className="col-md-1"></div>
                                                    <div className="col-md-7" style={{ textAlign: "left" }}>
                                                        {this.state.username}
                                                    </div>
                                                </div>
                                                <div className="col-md-12 row">
                                                    <div className="col-md-4" style={{ textAlign: "right" }}>
                                                        <b><i>メールアドレス:</i></b>
                                                    </div>
                                                    <div className="col-md-1"></div>
                                                    <div className="col-md-7" style={{ textAlign: "left" }}>
                                                        {this.state.email}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        }
    }
}
export { BuyerViewProfile }